import { render, staticRenderFns } from "./PopupTrigger.vue?vue&type=template&id=f49a6bda&scoped=true"
import script from "./PopupTrigger.vue?vue&type=script&lang=js"
export * from "./PopupTrigger.vue?vue&type=script&lang=js"
import style0 from "./PopupTrigger.vue?vue&type=style&index=0&id=f49a6bda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49a6bda",
  null
  
)

export default component.exports